import { nonUserApi } from './index'

const getSEPath = (string) => {
  if (!string) {
    return "search-engine-service";
  }
  return string?.length > 10 ? "search-engine-ca-service" : "search-engine-service";
}

const getSEPathFromCountryCode = (countryCode) => {
  return countryCode === "CA" ? "search-engine-ca-service" : "search-engine-service";
}

export const publicProfileApi = nonUserApi.injectEndpoints({
  endpoints: (builder) => ({
    getPublicProfile: builder.query({
      query: (profileId) => ({
        url: `api/v1/${getSEPath(profileId)}/public-profile`,
        method: "GET",
        params: { profileId }
      }),
    }),
    getPublicFinancialList: builder.query({
      query: (profileId) => ({
        url: `api/v1/${getSEPath(profileId)}/public-profile/financial-list`,
        method: "GET",
        params: { profileId },
      }),
    }),
    getPublicApplication: builder.query({
      query: (profileId) => ({
        url: `api/v1/${getSEPath(profileId)}/public-profile/applications`,
        method: "GET",
        params: { profileId },
      }),
    }),
    getPublicGiftsPagedList: builder.query({
      query: (filters) => ({
        url: `api/v2/${getSEPath(filters.profileId)}/public-profile/gifts/${filters.profileId}`,
        method: "POST",
        body: { ...filters },
      }),
    }),
    getPublicCounties: builder.mutation({
      query: (params) => ({
        url: `api/v1/${getSEPathFromCountryCode(params.country)}/public-profile/counties`,
        method: "POST",
        body: params.codes,
      }),
    }),
    getPublicDirectorsPagedList: builder.query({
      query: (filters) => ({
        url: `api/v1/${getSEPath(filters.profileId)}/public-profile/directors/${filters.profileId}`,
        method: "GET",
        params: { ...filters },
      }),
    }),
    getPublicTaxReturn: builder.query({
      query: (profileId) => ({
        url: `api/v1/${getSEPath(profileId)}/public-profile/tax-return`,
        method: "GET",
        params: { profileId },
      }),
    }),
    getPublicChartProvinceList: builder.query({
      query: (profileId) => ({
        url: `api/v1/${getSEPath(profileId)}/public-profile/charts/province-list`,
        method: "GET",
        params: { profileId },
      }),
    }),
    getPublicRangeAmountList: builder.query({
      query: (profileId) => ({
        url: `api/v1/${getSEPath(profileId)}/public-profile/charts/range-amount`,
        method: "GET",
        params: { profileId },
      }),
    }),
    getPublicRangeSectorList: builder.query({
      query: (profileId) => ({
        url: `api/v1/${getSEPath(profileId)}/public-profile/charts/range-sector`,
        method: "GET",
        params: { profileId },
      }),
    }),
    getPublicSector: builder.query({
      query: (profileId) => ({
        url: `api/v1/${getSEPath(profileId)}/public-profile/sector`,
        method: "GET",
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetPublicProfileQuery,
  useGetPublicFinancialListQuery,
  useGetPublicApplicationQuery,
  useGetPublicGiftsPagedListQuery,
  useGetPublicCountiesMutation,
  useGetPublicDirectorsPagedListQuery,
  useGetPublicTaxReturnQuery,
  useGetPublicChartProvinceListQuery,
  useGetPublicSectorQuery,
  useGetPublicRangeAmountListQuery,
  useGetPublicRangeSectorListQuery,
} = publicProfileApi;